import Img from "@casino/legacy/client/shared/images/Img";
import ActionIcons from "../ActionIcons";
import GameBadge from "../GameBadge";
import GameImageContainer from "../GameImageContainer";
import GameProvider from "../GameProvider";
import type GameThumbProps from "../GameThumbProps";
import Hover from "../Hover";
import useGameThumb from "../hooks/useGameThumb";
import getWatermarkHref from "./getWatermarkHref";

type Props = GameThumbProps & {
  isMobile: boolean;
  textAlign: string;
};

const BigThumb: FC<Props> = (props) => {
  const {
    game,
    isHoverEnabled,
    isFavouriteToggleVisible,
    preloadImg,
    isBadge = true,
  } = useGameThumb({ ...props, wide: true, isSmallThumbnail: true });

  return (
    <div
      className={
        "relative shrink-0 cursor-pointer rounded-lg overflow-hidden flex justify-center max-w-[calc(218px*2+theme(space.3))] max-h-[248px]"
      }
    >
      {isHoverEnabled && (
        <Hover game={game} gameHref={props.href ?? game.href ?? ""} />
      )}
      <GameProvider game={game} isBetRangeVisible={false} />
      <ActionIcons
        game={game}
        isFavouriteToggleVisible={isFavouriteToggleVisible}
      />
      {isBadge && <GameBadge game={game} />}
      <GameImageContainer {...props} className="-mx-1 xxsm:-mx-2 sm:mx-0">
        <Img
          preload={preloadImg}
          src={game.thumbUrlMob ?? ""}
          alt={game.name ?? ""}
          useDpr2x
          mark={getWatermarkHref(game.name)}
          width={448}
          height={248}
          fit="crop"
          crop="faces"
          className="w-full"
        />
      </GameImageContainer>
    </div>
  );
};

export default BigThumb;
